<template>
  <div id="tweetPictures">
    <div class="faultClass container">
      <h4>图文管理</h4>
      <ul class="clearfix">
        <li
          v-for="(item, index) in faultClassLists"
          :key="index"
          :class="{ 'warning-border': item.state === 0 }"
          class="faultClassListPart listPart"
          @click="selectFaultClass(item, index)"
        >
          {{ item.memo }}
          <!-- <span v-bind:class="{active:activeIndex===index}">
                            <i class="el-icon-check"></i>
                        </span> -->
          <span
            :class="{ warning: item.state === 0 }"
            class="exitBtn"
            @click.stop="exitFaultClass(item)"
            v-if="fauleAuth.exitFaultClass"
            >编辑</span
          >
        </li>
        <li
          class="addContent"
          @click="newFaultClass()"
          v-if="fauleAuth.newFaultClass"
        >
          <i class="el-icon-plus"></i>
        </li>
      </ul>
      <el-dialog
        :title="textMenu[dialogMenuStatus]"
        :visible.sync="dislogFaultClass"
        :close-on-click-modal="false"
        width="600px"
        @close="emptyDialog('FaultClassForm')"
      >
        <el-form
          ref="FaultClassForm"
          :model="FaultClassForm"
          label-width="100px"
          :label-position="labelPosition"
          :rules="FaultClassFormRules"
        >
          <el-form-item label="链接名称：">
            <el-select
              style="width: 100%"
              v-model="FaultClassForm.linkType"
              placeholder="请选择链接类型"
            >
              <el-option
                v-for="item in pictureLinkTypes"
                :key="item.id"
                :label="item.paraName"
                :value="item.paraValue"
              ></el-option>
            </el-select>
            <!--说明-->
            <div class="explain">
              <p>
                外部链接: 使用http协议，如：http://www.baidu.com，小程序支持跳出
              </p>
              <p>web-view: 小程序内部打开页面: 使用http协议</p>
              <p>小程序间跳转: 请使用JSON压缩格式,{"appId":"",path:""}</p>
              <p>小程序页面: 跳转小程序页面 如：/pages/index</p>
            </div>
          </el-form-item>
          <el-form-item label="链接地址：" prop="chainedAddress">
            <el-input
              clearable
              v-model.trim="FaultClassForm.chainedAddress"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input
              clearable
              type="number"
              v-model.trim="FaultClassForm.sort"
              :min="0"
              :max="99"
            ></el-input>
          </el-form-item>
          <el-form-item label="图文描述">
            <el-input
              clearable
              type="textarea"
              v-model.trim="FaultClassForm.memo"
            ></el-input>
          </el-form-item>
          <el-form-item label="图文归属:">
            <el-select
              style="width: 100%;"
              placeholder="请选择归属"
              v-model="FaultClassForm.memo1"
            >
              <el-option
                v-for="item in pictureAttributions"
                :key="item.id"
                :label="item.paraName"
                :value="item.paraValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select
              style="width: 100%"
              placeholder="请选择类型"
              v-model="FaultClassForm.memo2"
            >
              <el-option label="首页广告-popup弹出层" value="1"></el-option>
              <el-option label="首页-中部广告位" value="2"></el-option>
              <el-option label="首页底部广告" value="3"></el-option>
              <el-option label="首页banner轮播图" value="4"></el-option>
              <el-option label="我的-中部广告位" value="10"></el-option>
              <el-option label="我的-底部广告" value="11"></el-option>
              <el-option label="活动-推广-banner" value="20"></el-option>
              <el-option label="活动-推广-详情" value="21"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="展示图片：" prop="images" class="clearfix">
            <el-upload
              class="avatar-uploader fl"
              :data="postData"
              :accept="acceptImage"
              action="https://up.qiniup.com"
              :show-file-list="false"
              :on-success="handlePictureCardPreview"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="状态：">
            <el-switch
              v-model="FaultClassForm.state"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            v-if="dialogMenuStatus !== 'update'"
            type="success"
            @click="addEventFormSubmitBtn('FaultClassForm')"
            >添加</el-button
          >
          <el-button
            v-else
            type="success"
            @click="saveEventFormSubmitBtn('FaultClassForm')"
            >保存</el-button
          >
          <el-button @click="emptyDialog('FaultClassForm')">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { genUpToken } from "./com/qiniuToken.js";
import { getPermission } from "../../api/authRequest";
import {
  selectTweet,
  updateDetails,
  insertTweet,
  selectParameterInfoBusiness
} from "../../api/api";
export default {
  name: "tweetPictures",
  data() {
    const validateNumber = (rule, value, callback) => {
      if (/^100$|^(\d|[1-9]\d)$/.test(value) == false) {
        callback(new Error("请输入一个大于0,小于100的整数"));
      } else {
        callback();
      }
    };
    return {
      postData: { token: "" },
      qiniuaddr: "pic.allscs.cn", // 这是七牛云空间的外链默认域名
      ruleImg: "imageView2/0/q/75|imageslim", //规则
      dialogImageUrl: "", //故障大类图标
      dialogImageSrc: "", //故障分类图标
      imageUrl: "", //故障小类图标
      acceptImage: "image/jpeg,image/jpg,image/png",
      fileList2: [],
      defaultFaultClassId: "",
      labelPosition: "left",
      activeIndex: 0,
      activeFaultIndex: 0,
      faultClassLists: [],
      dislogFaultClass: false,
      dialogMenuStatus: "",
      textMenu: {
        update: "修改图文信息",
        create: "新增图文信息"
      },
      FaultClassForm: {
        chainedAddress: "",
        sort: "",
        memo: "",
        gppImages: "",
        memo1: "",
        memo2: "",
        linkType: "",
        state: ""
      },
      FaultClassFormRules: {
        faultTypesName: [
          { required: true, message: "请输入故障分类名称", trigger: "blur" }
        ],
        sort: [{ required: true, validator: validateNumber, trigger: "blur" }]
      },
      //故障部分
      dislogFault: false,
      dialogFaultStatus: "",
      textFaultMenu: {
        update: "修改故障",
        create: "新增故障"
      },
      FaultForm: {
        faultSubclassName: "",
        faultSubclassShortName: "",
        sort: "",
        images: ""
      },
      FaultFormRules: {
        faultSubclassShortName: [
          { required: true, message: "请输入故障简称", trigger: "blur" }
        ],
        faultSubclassName: [
          { required: true, message: "请输入故障名称", trigger: "blur" }
        ],
        sort: [{ required: true, validator: validateNumber, trigger: "blur" }]
      },
      faultLists: [],
      fauleAuth: {
        newFaultClass: false,
        exitFaultClass: true,
        deleFaultClass: true,
        newFault: false,
        exitFault: false,
        deleFault: false
      },
      // 图片归属
      pictureAttributions: [],
      picturePositions: [],
      pictureLinkTypes: []
    };
  },
  components: {},
  mounted() {
    this.getFaultTypesList();
    this.fauleAuth.newFaultClass = getPermission(
      "/api/basicSetting/faulttypes/insertFaultTypes"
    );
    this.fauleAuth.exitFaultClass = getPermission(
      "/api/basicSetting/faulttypes/updateFaultTypes"
    );
    this.fauleAuth.deleFaultClass = getPermission(
      "/api/basicSetting/faulttypes/deleteFaultTypes"
    );
    this.fauleAuth.newFault = getPermission(
      "/api/basicSetting/faultSubclass/insertFaultSubclass"
    );
    this.fauleAuth.exitFault = getPermission(
      "/api/basicSetting/faultSubclass/updateFaultSubclass"
    );
    this.fauleAuth.deleFault = getPermission(
      "/api/basicSetting/faultSubclass/deleteFaultSubclass"
    );

    this.getPictureAttribution();
    this.getPicturePosition();
    this.getPictureLinkType();
  },
  methods: {
    handlePictureCardPreview(res, file) {
      this.dialogImageUrl =
        "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      this.FaultClassForm.images = this.dialogImageUrl;
    },
    /*handlePictureCardPreview2(res, file) {
                this.dialogImageSrc = 'http://' + this.qiniuaddr + '/' + res.key +'?imageslim'
                this.FaultClassForm.bannerImages = this.dialogImageSrc
            },*/
    //获取图文
    getFaultTypesList() {
      console.log("获取图文");
      //所有
      let query = {
        startRow: 1,
        pageSize: 10
      };
      selectTweet(query)
        .then(res => {
          console.log("获取图文1");

          if (res.data.status == 100) {
            this.faultClassLists = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    /**
     * 图文归属
     */
    getPictureAttribution() {
      selectParameterInfoBusiness({
        paraType: "picture_attribution",
        startRow: 1,
        pageSize: 10000
      }).then(resp => {
        if (resp.data.results) {
          this.pictureAttributions = resp.data.results.list;
        }
      });
    },
    /**
     * 图片位置
     */
    getPicturePosition() {
      selectParameterInfoBusiness({
        paraType: "picture_position",
        startRow: 1,
        pageSize: 10000
      }).then(resp => {
        if (resp.data.results) {
          this.picturePositions = resp.data.results.list;
        }
      });
    },
    getPictureLinkType() {
      selectParameterInfoBusiness({
        paraType: "picture_link_type",
        startRow: 1,
        pageSize: 10000
      }).then(resp => {
        if (resp.data.results) {
          this.pictureLinkTypes = resp.data.results.list;
        }
      });
    },

    //新增故障分类
    newFaultClass() {
      this.dialogImageUrl = "";
      this.dialogImageSrc = "";
      this.dislogFaultClass = true;
      this.dialogMenuStatus = "create";
    },
    //确定新增故障分类
    addEventFormSubmitBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          // console.log('验证成功')
          let para = {
            chainedAddress: this.FaultClassForm.chainedAddress,
            memo: this.FaultClassForm.memo,
            sort: this.FaultClassForm.sort,
            gppImages: this.dialogImageUrl,
            memo1: this.FaultClassForm.memo1,
            memo2: this.FaultClassForm.memo2,
            linkType: this.FaultClassForm.linkType,
            state: this.FaultClassForm.state
          };
          insertTweet(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogFaultClass = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getFaultTypesList();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //编辑故障分类
    exitFaultClass(item) {
      this.dislogFaultClass = true;
      this.dialogMenuStatus = "update";
      this.FaultClassForm = Object.assign({}, item);
      this.dialogImageUrl = item.gppImages;
    },
    //确定保存故障分类
    saveEventFormSubmitBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          console.log("验证成功");
          let para = {
            id: this.FaultClassForm.id,
            chainedAddress: this.FaultClassForm.chainedAddress,
            memo: this.FaultClassForm.memo,
            sort: this.FaultClassForm.sort,
            gppImages: this.dialogImageUrl,
            memo1: this.FaultClassForm.memo1,
            memo2: this.FaultClassForm.memo2,
            linkType: this.FaultClassForm.linkType,
            state: this.FaultClassForm.state
          };
          updateDetails(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogFaultClass = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getFaultTypesList();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //删除故障分类
    deleFaultClass(item) {
      this.FaultClassForm = Object.assign({}, item);
      console.log(this.FaultClassForm.faultTypesId);
      this.$confirm("确认删除该故障分类?", "提示", {
        type: "warning"
      })
        .then(() => {
          let para = {
            faultTypesId: this.FaultClassForm.faultTypesId
          };
          deleteFaultTypes(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*刷新列表*/
                this.getFaultTypesList();
                // this.activeIndex=0;
                this.FaultClassForm = {};
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        })
        .catch(() => {});
    },
    //选择故障分类
    selectFaultClass(item, index) {
      this.activeIndex = index;
      this.FaultClassForm = Object.assign({}, item);
      this.defaultFaultClassId = this.FaultClassForm.faultTypesId;
      this.getFaultList();
    },
    //获取故障
    /*getFaultList(){
                const faulttypesId = this.defaultFaultClassId
                const faultData = {faulttypesId:faulttypesId}
                selectFaultSubclass(faultData).then(res => {
                    if (res.data.status == 100) {
                        this.faultLists = res.data.results
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },*/
    //清空dialog--故障分类
    emptyDialog(formName) {
      this.$refs[formName].resetFields();
      this.FaultClassForm = {};
      this.dislogFaultClass = false;
    },
    //清空dialog2--故障
    emptyFaultDialog(formName) {
      this.$refs[formName].resetFields();
      this.FaultForm = {};
      this.dislogFault = false;
      this.imageUrl = "";
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      this.FaultForm.images = this.imageUrl;
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 格式 和Png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    //新增故障
    newFault() {
      this.dislogFault = true;
      this.dialogFaultStatus = "create";
    },
    //确定新增故障
    addFaultFormSubmitBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          let para = {
            faulttypesId: this.defaultFaultClassId,
            faultSubclassName: this.FaultForm.faultSubclassName,
            faultSubclassShortName: this.FaultForm.faultSubclassShortName,
            images: this.FaultForm.images,
            sort: this.FaultForm.sort
          };
          insertFaultSubclass(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogFault = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getFaultList();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //编辑故障
    exitFault(item) {
      this.dislogFault = true;
      this.dialogFaultStatus = "update";
      this.FaultForm = Object.assign({}, item);
      this.imageUrl = this.FaultForm.images;
    },
    //确定保存故障
    saveFaultFormSubmitBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          let para = {
            faultSubclassId: this.FaultForm.faultSubclassId,
            faultSubclassName: this.FaultForm.faultSubclassName,
            faultSubclassShortName: this.FaultForm.faultSubclassShortName,
            images: this.FaultForm.images,
            sort: this.FaultForm.sort
          };
          updateFaultSubclass(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogFault = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getFaultList();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //删除故障
    deleFault(item) {
      this.FaultForm = Object.assign({}, item);
      this.$confirm("确认删除该故障?", "提示", {
        type: "warning"
      })
        .then(() => {
          let para = {
            faultSubclassId: this.FaultForm.faultSubclassId
          };
          deleteFaultSubclass(para)
            .then(res => {
              if (res.data.status == 100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*刷新列表*/
                this.getFaultList();
                this.FaultForm = {};
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        })
        .catch(() => {});
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    }
  },
  created: function() {
    var token = "";
    var policy = {};
    var bucket = "hohofast";
    var AK = "VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis";
    var SK = "sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31";
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucket;
    policy.deadline = deadline;
    token = genUpToken(AK, SK, policy);
    this.postData.token = token;
  },
  watch: {}
};
</script>

<style lang="scss" type="text/css" scoped>
#tweetPictures {
  .clearfix {
    clear: both;
    overflow: hidden;
  }
  .container {
    border-bottom: 1px solid #c6c6c6;
    padding-bottom: 20px;
    h4 {
      margin: 15px 0;
      font-weight: 500;
      font-size: 16px;
    }
    .listPart {
      width: 160px;
      float: left;
      border: 1px solid #10c55b;
      margin: 0 15px 10px 0;
      border-radius: 10px;
      min-height: 40px;
      line-height: 1.8;
      padding: 20px 0 40px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
      font-size: 13px;
      & > span:first-child {
        display: none;
      }
      p {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.8;
        text-align: center;
        font-size: 13px;
      }
      span.active {
        position: absolute;
        top: -1px;
        right: -1px;
        display: block;
        width: 30px;
        height: 30px;
        border-width: 16px;
        border-style: solid;
        border-color: #1abc9c #1abc9c #fff #fff;
        border-top-right-radius: 10px;
        i {
          position: absolute;
          font-size: 14px;
          color: #fff;
          top: -9px;
        }
      }
      span.exitBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 20px;
        left: 0;
        border-top: 1px solid #10c55b;
        z-index: 1;
        display: block;
        background-color: #d7ffe8;
        border-radius: 0 0 10px 10px;
        color: #10c55b;
      }
      span.warning {
        color: #e03b5b;
        background-color: #f8d7da;
        border-top: 1px solid #e03b5b;
      }
      i.activeDelBtn {
        display: none;
        position: absolute;
        top: 5px;
        left: 5px;
        color: #e03b5b;
      }
    }
    .warning-border {
      border: 1px solid #e03b5b;
    }

    .listPart:hover {
      box-shadow: 2px 2px 2px #c6c6c6;
    }
    .listPart:hover i.activeDelBtn {
      display: block;
    }
    .addContent {
      border: 1px dashed #c6c6c6;
      width: 50px;
      height: 50px;
      line-height: 50px;
      float: left;
      text-align: center;
      margin-top: 15px;
      cursor: pointer;
      i {
        font-size: 20px;
      }
    }
    .contentPart {
      width: 80px;
      float: left;
      border: 1px solid #c6c6c6;
      margin: 0 15px 10px 0;
      border-radius: 5px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
    }
    .activeContent {
      background-color: #1abc9c;
      color: #fff;
      border-color: #fff;
    }
  }
  .container:last-child {
    border-color: transparent;
  }
  .explain {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
  }
}
</style>
<style lang="scss">
#tweetPictures {
  .avatar-uploader {
    width: 180px;
    height: 180px;
    margin-right: 20px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 400px;
    height: 178px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// tweetPictures.vue?0164c58c